<script setup lang="ts">
import { computed, toRef } from 'vue';

import CheckTaskDetailsTitleAsset from '@/components/CheckTaskDetailsTitleAsset.vue';
import CheckTaskDetailsTitleSpot from '@/components/CheckTaskDetailsTitleSpot.vue';
import CheckTaskDetailsTitleSpotArea from '@/components/CheckTaskDetailsTitleSpotArea.vue';
import CheckTaskDetailsTitleWarehouse from '@/components/CheckTaskDetailsTitleWarehouse.vue';
import {
  isAssetCheckTask,
  isInventoryCheckTask,
  isSpotAreaCheckTask,
  isSpotCheckTask
} from '@/helpers/checkTaskType';
import { useYardTask } from '@/composables';

import type { CheckTaskViewData } from '@nova/core';

const props = defineProps<{
  task: CheckTaskViewData;
}>();

const task = toRef(props, 'task');

const { getRelatedObject } = useYardTask({ initialTask: task });

const relatedObject = computed(() => getRelatedObject());

const showInventoryTitle = computed(() => isInventoryCheckTask(task.value));
const showSpotTitle = computed(() => isSpotCheckTask(task.value) && relatedObject.value != null);
const showAssetTitle = computed(() => isAssetCheckTask(task.value) && relatedObject.value != null);
const showSpotAreaTitle = computed(
  () => isSpotAreaCheckTask(task.value) && relatedObject.value != null
);
</script>

<template>
  <check-task-details-title-warehouse v-if="showInventoryTitle" :task="task" />
  <check-task-details-title-spot v-else-if="showSpotTitle" :task="task" />
  <check-task-details-title-asset v-else-if="showAssetTitle" :task="task" />
  <check-task-details-title-spot-area v-else-if="showSpotAreaTitle" :task="task" />
</template>
